import {Component, OnInit, Inject, ViewEncapsulation, AfterViewInit, ViewChildren, OnDestroy} from '@angular/core';
import {DocumentService} from 'src/app/core/services/document.service';
import {MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
import {CommonService} from 'src/app/core/services/common.service';
import {NotificationService} from '../../../core/services/notification.service';
import {pdfDefaultOptions} from 'ngx-extended-pdf-viewer';
import { EnvService } from 'src/app/core/services/env.service';
import {
  EnumContractEnterpriseStatus,
  EnumContractStatus,
  EnumContractUserRole,
  EnumContractUserStatus
} from 'src/app/core/constants/contract';
import {HttpErrorResponse} from "@angular/common/http";
import {ToastrService} from "ngx-toastr";
import {TranslateService} from "@ngx-translate/core";
import {LIMIT_SIZE} from "../../../core/constants/common";

// Jquery function for disabling radio and checkbox
declare function disableFormFields(): any;

// Jquery function for disabling input
declare function disableFormInput(): any;

// Define document type file upload
const DocumentUpload = 1;

@Component({
  selector: 'app-view-document-reference',
  templateUrl: './view-document-reference.component.html',
  encapsulation: ViewEncapsulation.None
})

export class ViewDocumentReferenceComponent implements OnInit, AfterViewInit, OnDestroy {

  mainContractId: string;
  pdfFilePath: string;
  markPdf: any
  referenceContractId: string;
  BASE_URL = 'http://localhost:8091/api';
  authorization: any
  constructor(
    private commonService: CommonService,
    private documentService: DocumentService,
    private toastr: ToastrService,
    private translateService: TranslateService,
    public notificationService: NotificationService,
    public dialogRef: MatDialogRef<ViewDocumentReferenceComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private env: EnvService) {
    dialogRef.disableClose = false;
    this.mainContractId = data.mainContractId;
    this.pdfFilePath = data.pdfFilePath;
    this.referenceContractId = data.referenceContractId;
    pdfDefaultOptions.renderInteractiveForms = false;
    this.BASE_URL = env.is_private_app ? env.private_api_endpoint : env.public_api_endpoint;
    this.BASE_URL += '/file/view/contract';
    this.authorization = {
      Authorization: `Bearer ${sessionStorage.getItem('token')}`
    }
  }

  src: string;
  typeId: number;
  isFile = false;
  document: any ;
  dataDetail:any;
  public isLoadAllPdfSrc = false;
  public listPdfSrc = {};
  pdfSrc: any ;
  pdfSrcPrint: any ;
  EnumContractStatus = EnumContractStatus;
  activeFile: number = 0;
  fileSrc: any[] = [];

  @ViewChildren('focus') focus;

  /**
   * Init component
   */
  async ngOnInit() {
    this.notificationService.subscribeErrorService();
  await  this.getDocumentById(this.referenceContractId);
    // this.viewDocumentByFilePath();

  }

  ngOnDestroy(): void {
    this.notificationService.subscribeErrorService();
  }

  ngAfterViewInit() {
    setTimeout(_ => this.focus.first.nativeElement.focus(), 200);
  }

  /**
   * Get document by id
   */
  // getDocumentById(id) {
  //   if (id) {
  //     this.documentService.getDocumentById(id).subscribe(
  //       async rs => {
  //         if (rs && rs.data) {
  //           this.document = rs.data.contractDTO;
  //           if (this.document.mainContractAttachments) {
  //             // set loading
  //             this.document.mainContractAttachments.forEach(item => {
  //               item.loading = true;
  //             });
  //             const firstFile = this.document.mainContractAttachments[0];
  //             this.pdfSrc = await this.viewDocumentUploadNew(this.document.id, firstFile.path, firstFile.fileSize);
  //             // this.viewDocumentsUpload(this.document.id);
  //             // load các file còn lại
  //             this.document.mainContractAttachments.forEach(file => {
  //               if (file.path != firstFile.path) {
  //                 this.viewDocumentUploadNew(this.document.id, file.path, file.fileSize);
  //               }
  //             });
  //
  //             setTimeout(() => {
  //               const boxRight = document.getElementById('box-right');
  //               const boxLeft = document.getElementById('box-left');
  //               const boxCenter = document.getElementById('box-center');
  //               boxCenter.style.width = `calc(100% - ${boxRight.getBoundingClientRect().width}px - ${boxLeft.getBoundingClientRect().width}px)`;
  //               const tabs = document.getElementsByClassName('tab');
  //               if (tabs) {
  //                 Array.from({length: tabs.length}, (v, i) => i).forEach(index => {
  //                   const tab = tabs.item(index) as HTMLElement;
  //                   tab.style.width = 100 / this.document.mainContractAttachments.length + '%';
  //                 })
  //               }
  //             }, 100);
  //           } else {
  //             this.viewDocumentNew(this.document, rs.data.documentHtml);
  //           }
  //           if (this.document.mainContractAttachments) {
  //             this.commonService.getViewPdfsForDocument(id).subscribe(async (res) => {
  //               if (!res.data) {
  //                 return;
  //               }
  //               const fileSrc = [];
  //               const files = [];
  //               for await (const [index, item] of res.data.entries()) {
  //                 const file = new Blob([new Uint8Array(item.bytes)], { type: 'application/pdf' });
  //                 files.push(file);
  //                 const base64 = await this.blobToBinary(file);
  //                 fileSrc.push(base64);
  //               }
  //               if (fileSrc.length > 0) {
  //                 this.fileSrc = fileSrc;
  //                 this.src = fileSrc[this.activeFile];
  //               }
  //             })
  //             setTimeout(() => {
  //               const tabs = document.getElementsByClassName('tab-reference');
  //               if (tabs) {
  //                 Array.from({ length: tabs.length }, (v, i) => i).forEach(index => {
  //                   const tab = tabs.item(index) as HTMLElement;
  //                   tab.style.width = 100 / this.document.mainContractAttachments.length + '%';
  //                 })
  //               }
  //             }, 100);
  //           } else {
  //             this.viewDocumentByFilePath();
  //           }
  //         } else {
  //           this.dialogRef.close();
  //         }
  //       }
  //     );
  //   } else {
  //     this.dialogRef.close();
  //   }
  // }

  getDocumentById(id) {
    if (id) {
      this.documentService.getDocumentById(id).subscribe(
        async rs => {
          if (rs) {
            this.document = rs.data.contractDTO;
            this.dataDetail = rs.data;
            const firstFile = this.document.mainContractAttachments[0];
            this.pdfSrcPrint = await this.viewDocumentUploadNew(this.document.id, firstFile.path, firstFile.fileSize);
            this.viewDocument(rs.data);
            if (this.document.mainContractAttachments) {
              this.commonService.getViewPdfsForDocument(id).subscribe(async (res) => {
                if (!res.data) {
                  return;
                }
                const fileSrc = [];
                const files = [];
                for await (const [index, item] of res.data.entries()) {
                  const file = new Blob([new Uint8Array(item.bytes)], { type: 'application/pdf' });
                  files.push(file);
                  const base64 = await this.blobToBinary(file);
                  fileSrc.push(base64);
                }
                if (fileSrc.length > 0) {
                  this.fileSrc = fileSrc;
                  this.src = fileSrc[this.activeFile];
                }
              })
              setTimeout(() => {
                const tabs = document.getElementsByClassName('tab-reference');
                if (tabs) {
                  Array.from({ length: tabs.length }, (v, i) => i).forEach(index => {
                    const tab = tabs.item(index) as HTMLElement;
                    tab.style.width = 100 / this.document.mainContractAttachments.length + '%';
                  })
                }
              }, 100);
            }
          } else {
            this.dialogRef.close();
          }
        }
      );
    } else {
      this.dialogRef.close();
    }
  }

  /**
   * View document
   * @param typeId type document
   */
  viewDocument(data) {
    // this.isFile = true;
    //   this.viewDocumentUpload(data.contractDTO.id);

    this.typeId = data.contractDTO.typeId;
    // console.log((data.contractDTO.status != 0 && data.contractDTO.status != 1 && data.contractDTO.status != 3))
    if (this.typeId === DocumentUpload || (data.contractDTO.status != 0 && data.contractDTO.status != 1 && data.contractDTO.status != 3)) {
      // View document upload
      this.isFile = true;
      this.viewDocumentUpload(data.contractDTO.id);
    } else {
      // View document form
      this.src = data.documentHtml;
      disableFormFields();
      disableFormInput();
    }
  }


  viewDocumentByFilePath() {
    const data: ViewDocumentReferenceDto = {
      mainContractId: this.mainContractId,
      referenceContractId: this.referenceContractId,
      pdfFilePath: this.pdfFilePath
    };
    const queryString = Object.entries(data)
      .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
      .join('&');
    // const res = await this.commonService.getViewPdfForDocumentByFilePath(data).toPromise();
    this.src = `${this.BASE_URL}?${queryString}`;

    // this.commonService.getViewPdfForDocumentByFilePath(data).subscribe(
    //   res => {
    //     this.showPdf(res);
    //   }
    // );
  }

  /**
   * View document with upload
   * @param id Document id
   */
  viewDocumentUpload(id) {
    // return this.commonService.checkFilePdf(id).subscribe(
    //   rs => {
    //     return this.commonService.getViewPdfForDocument(id).subscribe(
    //       res => {
    //         this.showPdf(res);
    //       }
    //     );
    //   }
    // );
    this.isFile = true;
    return this.commonService.getViewPdfForDocument(id).subscribe(
      res => {
        this.showPdf(res);
      }
    );
  }

  public blobToFile = (theBlob: Blob, fileName: string): File => {
    const b: any = theBlob;
    // A Blob() is almost a File() - it's just missing the two properties below which we will add
    b.lastModifiedDate = new Date();
    b.name = fileName;

    // Cast to a File() type
    return theBlob as File;
  }

  /**
   * Show view pdf
   * @param blob Blob pdf
   */
  showPdf(blob: any) {
    // const file = new File([blob], null, { type: 'application/pdf' });
    const file = this.blobToFile(blob, 'application/pdf');
    this.commonService.readFile(file, (pdfSrc) => {
      this.src = pdfSrc;
      // console.log(pdfSrc);
    });
  }

  blobToBinary(blob: Blob) {
    return new Promise((resolve, reject) => {
      var reader = new FileReader();
      reader.onload = (e: any) => {
        resolve(e.target.result);
      };
      reader.readAsArrayBuffer(blob);
    })
  }
  openPDFByBrowser(id: string) {
    if (id) {
      this.documentService.downloadFileZip(id).subscribe(res => {
        if (window.top.navigator.msSaveOrOpenBlob) {
          // Store Blob in IE
          window.top.navigator.msSaveOrOpenBlob(res, this.document.name + '.zip');
        } else {
          // Store Blob in others
          const tA = document.body.appendChild(document.createElement('a'));
          tA.href = URL.createObjectURL(res);
          tA.download = this.document.code + ' - ' + this.document.name + '.zip';
          tA.style.display = 'none';
          tA.click();
          tA.parentNode.removeChild(tA);
        }
      });
    }
  }
  callApiWaterMark(){
    const currentFrame = document.getElementById('sample-iframe');
    if(currentFrame){
      currentFrame.remove()
    }
    let a = this.document.mainContractAttachments[this.activeFile].id
    this.documentService.getDocWithWaterMark(this.data.referenceContractId,a).subscribe( async (response: any) => {
      if(response){
        this.markPdf =  await this.commonService.readFileAsync(response);
      }
      // Create the Blob URL:
      const buffer = this.markPdf;
      const blob = new Blob([buffer], {
        type: 'application/pdf'
      });
      const objectURL = URL.createObjectURL(blob);

      // Create an iframe to demonstrate it:
      const iframe = document.createElement('iframe');
      iframe.id = 'sample-iframe';
      iframe.src = objectURL;
      document.body.appendChild(iframe);
      iframe.contentWindow.print();
      iframe.hidden = true
    },(err:HttpErrorResponse)=>{
      this.toastr.error(this.translateService.instant('messages.notGetPdf'))
    })
  }
  isString(value) {
    return typeof value === "string";
  }
  viewDocumentNew(document, htmlMerge) {
    this.viewDocumentUploadNew(this.document.id, this.document.filePath);
  }

  async viewDocumentUploadNew(contractId, pdfFilePath, size?) {
    const data: ViewDocumentReferenceDto = {
      pdfFilePath: pdfFilePath,
      mainContractId: contractId,
      referenceContractId: '',
    };
    const queryString = Object.entries(data)
      .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
      .join('&');
    // const res = await this.commonService.getViewPdfForDocumentByFilePath(data).toPromise();
    let pdfSrc;
    if (!this.env.pdfViewFullDownload && size && size > 10485760) {
      pdfSrc = `${this.BASE_URL}?${queryString}`;
      this.listPdfSrc[pdfFilePath] = pdfSrc;
      this.document.mainContractAttachments.forEach(item => {
        if (item.path == pdfFilePath) {
          item.loading = false;
        }
      });
      this.isLoadAllPdfSrc = this.document.mainContractAttachments.filter(item => {
        return item.loading;
      }).length == 0;
    } else {
      const res = await this.commonService.getViewPdfForDocumentByFilePath(data).toPromise();
      pdfSrc = await this.showPdfNew(res, pdfFilePath);
    }

    return pdfSrc;
  }
  async showPdfNew(blob: any, pdfFilePath: string) {
    const file = this.blobToFile(blob, 'application/pdf');
    const pdfSrc = await this.commonService.readFileAsync(file);
    this.listPdfSrc[pdfFilePath] = pdfSrc;
    this.document.mainContractAttachments.forEach(item => {
      if (item.path == pdfFilePath) {
        item.loading = false;
      }
    });
    this.isLoadAllPdfSrc = this.document.mainContractAttachments.filter(item => {
      return item.loading
    }).length == 0;
    return pdfSrc;
  }
  async doPrint() {
    if(this.document.status !==this.EnumContractStatus.FINISHED ||
      (this.document.isConfirmBCT==true && this.document.bctConfirmStatus !== this.EnumContractStatus.FINISHED) ){
      this.callApiWaterMark()
    }else{
      const currentFrame = document.getElementById('sample-iframe');
      if(currentFrame){
        currentFrame.remove()
      }
      // this.printService.print();
      if(this.isString(this.pdfSrcPrint)){
        if(this.pdfSrcPrint =='notPDF'){
          this.toastr.error(this.translateService.instant('messages.notPdf'))
          return
        }else if(this.pdfSrcPrint.includes('file/view/contract')&&this.document.mainContractAttachments[this.activeFile].fileSize > LIMIT_SIZE){
          this.callApiWaterMark();
          return
        }
      }

      if(this.pdfSrcPrint.byteLength == undefined||this.pdfSrcPrint.byteLength == 0){
        this.toastr.error(this.translateService.instant('messages.errorPdf'))
        return
      }
      this.pdfSrcPrint = this.listPdfSrc[this.document.mainContractAttachments[this.activeFile].path];
      const buffer = this.pdfSrcPrint;
      const blob = new Blob([buffer], {
        type: 'application/pdf'
      });
      const objectURL = URL.createObjectURL(blob);

      // Create an iframe to demonstrate it:
      const iframe = document.createElement('iframe');
      iframe.id = 'sample-iframe';
      iframe.src = objectURL;
      document.body.appendChild(iframe);
      iframe.contentWindow.print();
      iframe.hidden = true
    }
  }
  changeFile(index: number) {
    this.activeFile = index;
    if (this.fileSrc.length) {
      this.src = this.fileSrc[index];
    }
  }
}
